import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
const benefits = [{
  icon: '📚',
  title: '6 Volumi · 60+ Lezioni',
  desc: 'Il tuo anno completo di Pilates già pianificato — apri, leggi e insegni.',
  bullets: ['Classico Rinnovato, Force, Flow, Elementi, Soft e Full Power', 'Progressioni reali da principiante ad avanzato', 'Cueing pronti da pronunciare parola per parola'],
  value: '€97'
}, {
  icon: '🩺',
  title: 'Protocolli Clinici',
  desc: 'Lavora in sicurezza tecnica con le lesioni più comuni.',
  bullets: ['Ernie e discopatie lombari', 'Scoliosi, ipercifosi e iperlordosi', 'Dolore cervicale e dolore alle spalle'],
  value: '€57'
}, {
  icon: '🤰',
  title: 'Popolazioni Speciali',
  desc: 'Acquisisci nuove allieve con adattamenti professionali pronti.',
  bullets: ['Gravidanza trimestre per trimestre', 'Terza età con osteoporosi', 'Adattamenti sicuri e graduali'],
  value: '€47'
}, {
  icon: '🌊',
  title: 'Pianificazione "Flow"',
  desc: 'Lezioni senza pause scomode, con ritmo e transizioni di alto livello.',
  bullets: ['Modelli di transizioni fluide', 'Struttura energetica per blocchi', 'Chiusura con senso di realizzazione'],
  value: '€49'
}];
const headlineStats = [{
  num: '350+',
  label: 'Pagine'
}, {
  num: '6',
  label: 'Volumi'
}, {
  num: '+12',
  label: 'Mesi di lezioni'
}, {
  num: '100%',
  label: 'Editabile'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-1">
      <div className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-2"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-3">
        <div className="text-center mb-10 sm:mb-14" data-id="element-4">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-5">
            🎁 Cosa riceverai
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-6">
            Tutto ciò di cui hai bisogno,{' '}
            <span className="text-primary" data-id="element-7">in un unico posto</span>.
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-8">
            Quattro pilastri di contenuto tecnico per eliminare lo stress
            settimanale ed elevare la qualità di ogni lezione che dai.
          </p>
        </div>

        <div className="grid grid-cols-4 gap-2 sm:gap-4 mb-10 sm:mb-14 max-w-3xl mx-auto" data-id="element-9">
          {headlineStats.map((s, i) => <div key={i} className="bg-bg-alt border border-border-light rounded-xl py-3 sm:py-4 px-2 text-center" data-id="element-10">
              <p className="text-primary font-black text-lg sm:text-2xl leading-none mb-1" data-id="element-11">
                {s.num}
              </p>
              <p className="text-text-sec text-[10px] sm:text-xs font-medium uppercase tracking-wider" data-id="element-12">
                {s.label}
              </p>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6" data-id="element-13">
          {benefits.map((benefit, i) => <article key={i} className="bg-bg-alt rounded-3xl border border-border-light p-6 sm:p-8 flex flex-col relative overflow-hidden hover:-translate-y-1 hover:border-primary/40 hover:shadow-[0_18px_40px_-15px_rgba(139,111,191,0.3)] transition-all duration-300 group shadow-[0_4px_20px_-10px_rgba(90,70,120,0.12)]" data-id="element-14">
              <div className="absolute top-5 right-5 sm:top-6 sm:right-6 flex items-center gap-1.5 bg-cta-green/10 text-cta-green border border-cta-green/25 px-2.5 py-1 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-wider" data-id="element-15">
                <Check className="w-3 h-3" data-id="element-16" />
                Incluso
              </div>

              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/25 flex items-center justify-center text-3xl mb-5 shadow-inner" data-id="element-17">
                {benefit.icon}
              </div>

              <div className="mb-2" data-id="element-18">
                <h3 className="text-xl sm:text-2xl font-black text-text-main leading-tight" data-id="element-19">
                  {benefit.title}
                </h3>
                <p className="text-text-sec text-xs sm:text-sm font-medium mt-1" data-id="element-20">
                  Valore:{' '}
                  <span className="text-text-main font-bold line-through" data-id="element-21">
                    {benefit.value}
                  </span>{' '}
                  · Oggi:{' '}
                  <span className="text-cta-green font-bold" data-id="element-22">
                    Gratis con il Kit
                  </span>
                </p>
              </div>

              <p className="text-text-sec text-sm sm:text-base leading-relaxed mb-5" data-id="element-23">
                {benefit.desc}
              </p>

              <ul className="space-y-2 mt-auto" data-id="element-24">
                {benefit.bullets.map((b, j) => <li key={j} className="flex items-start gap-2.5 text-text-main text-sm sm:text-[15px] font-medium" data-id="element-25">
                    <Check className="w-4 h-4 text-cta-green flex-shrink-0 mt-0.5" data-id="element-26" />
                    <span data-id="element-27">{b}</span>
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}